var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c("div", { staticClass: "responsible-gaming-history" }, [
        !_vm.accountSummaryFlow
          ? _c("h1", [
              _vm._v(">" + _vm._s(_vm.$t("Account.ResponsibleGamingHistory")))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "caca" }, [
          _vm.brandTemplate !== "generic_2"
            ? _c(
                "div",
                {
                  class: [
                    "responsible-gaming-filter datefilter",
                    { active: _vm.filterExpanded }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.toggleFilter()
                    }
                  }
                },
                [
                  _c("div", [
                    _c("div", { staticClass: "date_range_text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.TransactionHistory.History"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date_range" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(
                            _vm.dateFrom,
                            _vm.dateFormats.longDate
                          )
                        ) +
                          " " +
                          _vm._s(
                            _vm.$t("Account.TransactionHistory.History.To")
                          ) +
                          " " +
                          _vm._s(
                            _vm._f("moment")(
                              _vm.dateTo,
                              _vm.dateFormats.longDate
                            )
                          )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter" }, [
                    _vm._v(_vm._s(_vm.$t("Account.TransactionHistory.Filter")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.brandTemplate === "generic_2"
            ? _c("div", { staticClass: "daterange_holder" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-date",
                    class: { active: _vm.calendarDateFrom },
                    on: {
                      click: function($event) {
                        return _vm.showCalendarDateFrom()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "headhint" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.TransactionHistory.History.DateFrom")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date_from_to" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(
                            _vm.dateFrom,
                            _vm.dateFormats.longDateWitDayName
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon_calendar" })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-date",
                    class: { active: _vm.calendarDateTo },
                    on: {
                      click: function($event) {
                        return _vm.showCalendarDateTo()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "headhint" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Account.TransactionHistory.History.To"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date_from_to" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(
                            _vm.dateTo,
                            _vm.dateFormats.longDateWitDayName
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon_calendar" })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.filterExpanded
            ? _c("div", { staticClass: "calendar-container" }, [
                _vm.brandTemplate !== "generic_2"
                  ? _c("div", { staticClass: "calendar-buttons" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn-date",
                          class: { active: _vm.calendarDateFrom },
                          on: {
                            click: function($event) {
                              return _vm.showCalendarDateFrom()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "headhint" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.TransactionHistory.History.DateFrom"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "date_from_to" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.dateFrom,
                                  _vm.dateFormats.longDateWitDayName
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-date",
                          class: { active: _vm.calendarDateTo },
                          on: {
                            click: function($event) {
                              return _vm.showCalendarDateTo()
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "headhint" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Account.TransactionHistory.History.To")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "date_from_to" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  _vm.dateTo,
                                  _vm.dateFormats.longDateWitDayName
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "calendar" },
                  [
                    _vm.calendarDateFrom
                      ? _c("v-date-picker", {
                          attrs: {
                            max: _vm.dateToFormated,
                            "full-width": true,
                            "no-title": true,
                            locale: _vm.currentLocale
                          },
                          model: {
                            value: _vm.dateFromFormated,
                            callback: function($$v) {
                              _vm.dateFromFormated = $$v
                            },
                            expression: "dateFromFormated"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.calendarDateTo
                      ? _c("v-date-picker", {
                          attrs: {
                            min: _vm.dateFromFormated,
                            max: _vm.dateMaxFormated,
                            "full-width": true,
                            "no-title": true,
                            locale: _vm.currentLocale
                          },
                          model: {
                            value: _vm.dateToFormated,
                            callback: function($$v) {
                              _vm.dateToFormated = $$v
                            },
                            expression: "dateToFormated"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "apply" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { "x-large": "" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.fetchHistory()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("Account.TransactionHistory.Apply"))
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.accountSummaryFlow && _vm.noOfPages > 0
            ? _c(
                "div",
                { staticClass: "select-page" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.page === 0 },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.fetchHistory("minus")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.TransactionHistory.History.Previous")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.page === _vm.noOfPages },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.fetchHistory("plus")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Account.TransactionHistory.History.Next")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.loader
          ? _c("div", { staticClass: "loading" }, [_c("dots-loader")], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.loader &&
        (!_vm.filterExpanded || _vm.brandTemplate !== "generic_2")
          ? _c("div", { staticClass: "caca" }, [
              _vm.accountSummaryFlow && _vm.noOfPages > 0
                ? _c(
                    "div",
                    { staticClass: "select-page" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-btn",
                          attrs: { disabled: _vm.page === 0 },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.fetchHistory("minus")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.TransactionHistory.History.Previous"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-btn",
                          attrs: { disabled: _vm.page === _vm.noOfPages },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.fetchHistory("plus")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.TransactionHistory.History.Next")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "txn" },
                [
                  _vm._l(_vm.items, function(item, index) {
                    return _c("div", { key: index, staticClass: "txn__tx" }, [
                      _c("div", { staticClass: "txn__tx__header" }, [
                        _c("div", { staticClass: "txn__tx__header__name" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txn__tx__header__date" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.cdate,
                                  _vm.dateFormats.longDate
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.cdate,
                                  _vm.dateFormats.longTime
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "txn__tx__body" }, [
                        _c("div", { staticClass: "txn__tx__body__curr" }, [
                          item.status === "PENDING"
                            ? _c("div", { staticClass: "txn__tx__body__txt" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.ResponsibleGamingHistory.NewValue"
                                    )
                                  ) + ":"
                                )
                              ])
                            : _c("div", { staticClass: "txn__tx__body__txt" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.ResponsibleGamingHistory.CurrentValue"
                                    )
                                  ) + ":"
                                )
                              ]),
                          _vm._v(" "),
                          item.unit === "AMOUNT"
                            ? _c(
                                "div",
                                { staticClass: "txn__tx__body__curr__amt" },
                                [
                                  item.value
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.noDecimalsFormat(item.value)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v(_vm._s("-"))])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.unit === "MINUTES"
                            ? _c(
                                "div",
                                { staticClass: "txn__tx__body__curr__min" },
                                [
                                  item.name === "Session Time Limit"
                                    ? _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.value || "-"))
                                        ]),
                                        _vm._v(" "),
                                        item.value && item.value === 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Minute"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.value && item.value !== 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Minutes"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.value / 60 || "-"))
                                        ]),
                                        _vm._v(" "),
                                        item.value && item.value / 60 === 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Hour"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.value && item.value / 60 !== 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Hours"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txn__tx__body__prev" }, [
                          item.status === "PENDING"
                            ? _c("div", { staticClass: "txn__tx__body__txt" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.ResponsibleGamingHistory.CurrentValue"
                                    )
                                  ) + ":"
                                )
                              ])
                            : _c("div", { staticClass: "txn__tx__body__txt" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.ResponsibleGamingHistory.PreviousValue"
                                    )
                                  ) + ":"
                                )
                              ]),
                          _vm._v(" "),
                          item.unit === "AMOUNT"
                            ? _c(
                                "div",
                                { staticClass: "txn__tx__body__prev__amt" },
                                [
                                  item.pvalue
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.noDecimalsFormat(item.pvalue)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v(_vm._s("-"))])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.unit === "MINUTES"
                            ? _c(
                                "div",
                                { staticClass: "txn__tx__body__prev__min" },
                                [
                                  item.name === "Session Time Limit"
                                    ? _c("div", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.pvalue || "-"))
                                        ]),
                                        _vm._v(" "),
                                        item.pvalue && item.pvalue === 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Minute"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.pvalue && item.pvalue !== 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Minutes"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _c("div", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(item.pvalue / 60 || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        item.pvalue && item.pvalue / 60 === 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Hour"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.pvalue && item.pvalue / 60 !== 1
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.ResponsibleGamingHistory.Hours"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txn__tx__body__type" }, [
                          _c("div", { staticClass: "txn__tx__body__txt" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Account.ResponsibleGamingHistory.Type")
                              ) + ":"
                            )
                          ]),
                          _vm._v(" "),
                          item.status
                            ? _c("span", [_vm._v(_vm._s(item.status))])
                            : _c("span", [_vm._v(_vm._s("-"))])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txn__tx__body__due" }, [
                          _c("div", { staticClass: "txn__tx__body__txt" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Account.ResponsibleGamingHistory.DueDate"
                                )
                              ) + ":"
                            )
                          ]),
                          _vm._v(" "),
                          item.duedate
                            ? _c(
                                "div",
                                { staticClass: "txn__tx__body__due__date" },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          item.duedate,
                                          _vm.dateFormats.longDate
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          item.duedate,
                                          _vm.dateFormats.longTime
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _c("div", [_vm._v(_vm._s("-"))])
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.items || _vm.items.length === 0
                    ? _c("div", { staticClass: "no-data" }, [
                        _vm._v(_vm._s(_vm.$t("Account.Table.NoData")))
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51d3224c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d3224c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ResponsibleGamingHistoryComponent.vue
// module id = null
// module chunks = 